import React from 'react';
import AdminMemoryTypes from '../components/Admin/AdminMemoryTypes';

const AdminMemoryTypesPage: React.FC = () => {
  return <AdminMemoryTypes />;
};

export default AdminMemoryTypesPage;